import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_PHONENUMBER_SERVER } from '@/app/module/phonenumbers/definitions'
import { setPhoneNumberFiles } from '@/app/module/phonenumbers/store/phone-number-files.slice'
import { PhoneNumber } from '@/app/module/phonenumbers/types'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetPhoneNumber = (id: number) => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getOrgDid.useQuery(
    {
      orgId: orgId.toString(),
      didId: id.toString(),
    },
    { skip: !orgId || !id },
  )

  useEffect(() => {
    if (!res.data) {
      return
    }

    dispatch(setPhoneNumberFiles({ files: (res.data as PhoneNumber).files }))
  }, [res.data, dispatch])

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-phonenumber-failure': {
          type: 'error',
          message: ERROR_GET_PHONENUMBER_SERVER,
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
